/** Choose only workspaces returned by the membership-checked API. */
export function selectWorkspace<T extends { id: string; owner_type: string }>(
  workspaces: readonly T[],
  requestedId: string | null,
): T | null {
  return workspaces.find((workspace) => workspace.id === requestedId)
    ?? workspaces.find((workspace) => workspace.owner_type === "user")
    ?? workspaces[0]
    ?? null;
}

/** Preserve route filters when the selected workspace becomes part of a URL. */
export function workspaceSearch(search: string, workspaceId: string): string {
  const params = new URLSearchParams(search);
  params.set("workspace_id", workspaceId);
  return `?${params.toString()}`;
}
